/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ToolUsageClientToolBreakdownRow,
  ToolUsageClientToolBreakdownRow$inboundSchema,
} from "./toolusageclienttoolbreakdownrow.js";

/**
 * Per-tool MCP and tool usage grouped by MCP client
 */
export type GetToolUsageClientToolBreakdownResult = {
  /**
   * Per-tool usage rows grouped by MCP client
   */
  clientToolBreakdown: Array<ToolUsageClientToolBreakdownRow>;
};

/** @internal */
export const GetToolUsageClientToolBreakdownResult$inboundSchema: z.ZodMiniType<
  GetToolUsageClientToolBreakdownResult,
  unknown
> = z.pipe(
  z.object({
    client_tool_breakdown: z.array(
      ToolUsageClientToolBreakdownRow$inboundSchema,
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "client_tool_breakdown": "clientToolBreakdown",
    });
  }),
);

export function getToolUsageClientToolBreakdownResultFromJSON(
  jsonString: string,
): SafeParseResult<GetToolUsageClientToolBreakdownResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      GetToolUsageClientToolBreakdownResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetToolUsageClientToolBreakdownResult' from JSON`,
  );
}
